import pedigreeService from "./admin/pedigreeService";
import { api } from "./api";
import { PedigreeTypes } from "@/constants";

export const getDogsAttributes = async (): Promise<object> => {
    const { data } = await api.get<object>(`/Lookups/dog`);
    return data;
}

export const getPuppyAttributes = async (): Promise<object> => {
    const { data } = await api.get<object>(`/Lookups/puppy`);
    return data;
}

export const getDnaStatuses = async (): Promise<object> => {
    const { data } = await api.get<object>(`/Lookups/dnastatuses`);
    return data;
}

export const getPedigreePrintTypesList = function(){
    return [
        { name: "Pedigree: Digital Only", id: PedigreeTypes.PedigreeDigital, printable: false },
        { name: "Pedigree: Small", id: PedigreeTypes.PedigreeSmall, printable: true },
        { name: "Pedigree: Large", id: PedigreeTypes.PedigreeLarge, printable: true },
        { name: "Progeny: Digital Only", id: PedigreeTypes.ProgenyDigital, printable: false },
      ];
};

export const isDogReportTypePedigree = function(reportType: number){
    return reportType == PedigreeTypes.PedigreeDigital || reportType == PedigreeTypes.PedigreeLarge ||reportType == PedigreeTypes.PedigreeSmall;
}
export const isDogReportTypeProgeny = function(reportType: number){
    return reportType == PedigreeTypes.ProgenyDigital;
}

export default {
    getDogsAttributes,
    getPuppyAttributes,
    getDnaStatuses,
    getPedigreePrintTypesList,
    isDogReportTypePedigree,
    isDogReportTypeProgeny,
}